import Component from "@glimmer/component";
import { Task, task } from "ember-concurrency";
import { service } from "@ember/service";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { instanceOf, shape } from "prop-types";
import { tracked } from "@glimmer/tracking";
import Server from "glesys-controlpanel/models/server";

import GModalHeader from "glesys-controlpanel/components/g-modal/header";
import GModalBody from "glesys-controlpanel/components/g-modal/body";
import GModalFooter from "glesys-controlpanel/components/g-modal/footer";

import TaskForm from "glesys-controlpanel/components/task-form";
import Label from "glesys-controlpanel/components/label";
import GInput from "glesys-controlpanel/components/g-input";
import GButton from "glesys-controlpanel/components/g-button";
import modalClose from "glesys-controlpanel/helpers/modal-close";

import { t } from "ember-intl";
import { on } from "@ember/modifier";

@forbidExtraArgs
export default class ModalsServerEditHostName extends Component {
  @service modal;

  @arg(
    shape({
      server: instanceOf(Server).isRequired,
      task: instanceOf(Task).isRequired,
    }).isRequired,
  )
  params;

  get server() {
    return this.args.params.server;
  }

  get task() {
    return this.args.params.task;
  }

  @tracked hostname = this.server.hostname;

  submitTask = task(async () => {
    await this.task.perform({ hostname: this.hostname });
    this.modal.close();
  });

  onChange = ({ hostname }) => (this.hostname = hostname);

  get isDisabled() {
    return !this.hostname || this.task.isRunning;
  }

  <template>
    <GModalHeader>
      {{t "label.edit-name-for" name=this.server.id}}
    </GModalHeader>
    <GModalBody>
      <TaskForm id="server-edit-hostname" @onChange={{this.onChange}} @task={{this.submitTask}}>
        <Label for="server-hostname">
          {{t "label.name"}}
        </Label>
        <GInput
          id="server-hostname"
          data-test-server-hostname
          name="hostname"
          value={{this.hostname}}
          required={{true}}
          minlength="2"
          {{! eslint-disable-next-line ember/template-no-autofocus-attribute }}
          autofocus
        />
      </TaskForm>
    </GModalBody>
    <GModalFooter>
      <GButton class="mr-2" @color="gray" {{on "click" (modalClose)}}>
        {{t "button.cancel"}}
      </GButton>
      <GButton
        data-test-server-edit-hostname-submit
        @type="submit"
        @color="blue"
        @disabled={{this.isDisabled}}
        form="server-edit-hostname"
      >
        {{t "button.update"}}
      </GButton>
    </GModalFooter>
  </template>
}
